export default [
  {
    url: '/',
    name: 'Home',
    slug: 'home',
    icon: 'HomeIcon',
    i18n: 'Home',
  },
  {
    url: '/collection',
    name: 'Collection',
    slug: 'collection-list',
    icon: 'StarIcon',
    i18n: 'Collection',
  },
  {
    url: '/product',
    name: 'Product',
    slug: 'product-list',
    icon: 'FilmIcon',
    i18n: 'Product',
  },
  {
    url: '/review',
    name: 'Product Review',
    slug: 'review-list',
    icon: 'BookOpenIcon',
    i18n: 'Product Review',
  },
  {
    url: '/newsletter',
    name: 'Newsletter',
    slug: 'newsletter-list',
    icon: 'BookOpenIcon',
    i18n: 'Newsletter',
  },
  {
    url: '/purchase',
    name: 'Purchase',
    slug: 'purchase-list',
    icon: 'ShoppingBagIcon',
    i18n: 'Purchase',
  },
  {
    url: '/widget',
    name: 'Widget',
    slug: 'widget-list',
    icon: 'ShoppingBagIcon',
    i18n: 'Widget',
  },
  {
    url: '/faq',
    name: 'FAQ',
    slug: 'faq-list',
    icon: 'BookOpenIcon',
    i18n: 'FAQ',
  },
  {
    url: '/latest-video',
    name: 'Latest Video',
    slug: 'latest-video-list',
    icon: 'BookOpenIcon',
    i18n: 'Latest Video',
  },
  {
    url: '/advisor',
    name: 'Advisor',
    slug: 'advisor-list',
    icon: 'BookOpenIcon',
    i18n: 'Advisor',
  },
  {
    url: '/appointment',
    name: 'Appointment',
    slug: 'appointment-list',
    icon: 'ListIcon',
    i18n: 'Appointment',
  },
  {
    url: '/discovery',
    name: 'Discovery',
    slug: 'discovery-list',
    icon: 'BookOpenIcon',
    i18n: 'Discovery',
  },
  {
    url: '/hello-dna-profile',
    name: 'Hello DNA Profile',
    slug: 'hello-dna-profile-list',
    icon: 'ListIcon',
    i18n: 'Hello DNA Profile',
  },
  {
    url: '/hello-dna-disease',
    name: 'Hello DNA Disease',
    slug: 'hello-dna-disease-list',
    icon: 'BookOpenIcon',
    i18n: 'Hello DNA Disease',
  },
  {
    url: '/user',
    name: 'User',
    slug: 'user-list',
    icon: 'UsersIcon',
    i18n: 'User',
  },
  {
    url: '/admin',
    name: 'Admin',
    slug: 'admin-list',
    icon: 'UserIcon',
    i18n: 'Admin',
  },
  {

    url: '/advisor-settlement',
    name: 'Advisor Settlement',
    slug: 'advisor-settlement',
    icon: 'ListIcon',
    i18n: 'AdvisorSettlement',
  },
  {
    url: '/admin-role',
    name: 'Admin Role',
    slug: 'admin-role-list',
    icon: 'SlidersIcon',
    i18n: 'Admin Role',
  },
];
